import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, UserRound } from "lucide-react";
import ProfileImageComponent from "./ProfileImageComponent/ProfileImageComponent";
import PersonalDetails from "./PersonalDetails/PersonalDetails";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import "./UserProfile.css";

export default function UserProfile() {
  const [userData, setUserData] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { profileData } = useSelector((store) => store.data);
  useEffect(() => {
    setUserData(profileData);
  }, [profileData]);

  return (
    <div className="user-profile-page">
      <div className="up-header-card">
        <button type="button" className="up-back-btn" onClick={() => navigate(-1)} aria-label="Back">
          <ArrowLeft size={16} />
        </button>
        <span className="up-header-icon">
          <UserRound size={17} color="#2A6591" />
        </span>
        <div className="up-header-text">
          <div className="up-header-title-row">
            <span className="up-header-title-text">{t('user_profile')}</span>
            <span className="up-header-pill">{t('user_profile')}</span>
          </div>
          <div className="up-header-subtitle">View and manage your personal profile details</div>
        </div>
      </div>

      <div className="up-body">
        <div className="up-photo-card">
          <ProfileImageComponent profileData={userData && userData[0]} />
        </div>

        <div className="up-details-col">
          <PersonalDetails userData={userData && userData[0]} />
        </div>
      </div>
    </div>
  );
}
